/**
 * Clase que contiene métodos de interacción con Storage de Firebase.
**/

import { storage } from "./FirebaseConfig";
import { ref, listAll, getDownloadURL, deleteObject } from "firebase/storage";

//Método para listar los archivos que tiene almacenado el usuario en Storage, a partir de su
//uuid de usuario
export const listUserFiles = async (userId, path) => {
  try {
    //se listan los ficheros y carpetas dentro de la carpeta mixoutfit
    const userFolderRef = ref(storage, `files/${userId}/mixoutfit/${path}`);
    const result = await listAll(userFolderRef);

    //Se separan ficheros y carpetas
    const files = await Promise.all(
      result.items.map(async (item) => {
         //Se recupera la url de cada archivo (esto excluye carpetas)
        const url = await getDownloadURL(item);
        //Se retorna el nombre del archivo y la url
        return { name: item.fullPath.split('/').pop(), url };
      })
    );
    //se guardan las carpetas
    const folders = result.prefixes.map((folder) => folder.fullPath.split('/').pop());

    //Se retornan al método de llamada los ficheros y carpetas
    return { files, folders };
  } catch (error) {
    console.error("Error fetching user files:", error);
    return { files: [], folders: [] };
  }
};

//Método para eliminar ficheros en Storage
export const deleteUserFile = async (userId, path, fileName) => {
  try {
    const fileRef = ref(storage, `files/${userId}/mixoutfit/${path}/${fileName}`);
    await deleteObject(fileRef);
    console.log(`File ${fileName} deleted successfully`);
    return true;
  } catch (error) {
    console.error("Error deleting file:", error);
    return false;
  }
};